import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "withLink",
  pure: false,
})
export class LocalizedLinkPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  public transform(value: string, linkKey: string, isExternal = true): string {
    const placeholderRegex = /##(.*?)##/g;
    const link = this.translateService.instant(linkKey);
    const translatedText = this.translateService.instant(value);

    const target = isExternal ? "_blank" : "_self";

    return translatedText.replace(
      placeholderRegex,
      (_match: string, placeholderName: string): string =>
        `<a href="${link}" target="${target}">${placeholderName.trim()}</a>`,
    );
  }
}
